import React from "react";
import './abstracts.css';
import docFile from './VETOMAC_2023_Word_Template.docx';

function Abstracts() {

    const downloadTemplate = () => {
        fetch(docFile).then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'VETOMAC_2023_Word_Template.docx';
                alink.click();
            })
        })
    }

    // const downloadZipTemplate = () => {
    //     fetch(zipFile).then(response => {
    //         response.blob().then(blob => {
    //             const fileURL = window.URL.createObjectURL(blob);
    //             let alink = document.createElement('a');
    //             alink.href = fileURL;
    //             alink.download = 'VETOMAC_2023_LaTeX_Template.zip';
    //             alink.click();
    //         })
    //     })
    // }

    return (
        <div>
            <div className="abstract">
                <h2 className="compTitle">Call for Abstracts</h2>
                <p>We invite you to submit an abstract for the 18th VETOMAC conference (VETOMAC 2023), which will be held at the Indian Institute of Technology, Roorkee on 18-20 December 2023.</p>
                <p>Organized over the years at various venues across Asia, Europe, Americas, and Australia, with the involvement of academic and research institutes and active participation from industry, VETOMAC has been successful in bringing together researchers and engineers across the globe, to share their research experiences in the field of vibration engineering and technology of machinery.</p>
                <p>All submissions are to be made through the EquinOCS online submission system, and the conference proceedings of the peer-reviewed full-length papers will be published online on Springer, after the conference presentation.</p>
            </div>
            <div style={{background: '#F67280', padding: '3vmax 10vmax', textAlign: 'center'}}>
                <p className="deadline">The deadline for full paper submission is October 8, 2023. Please email the organizing committee at vetomac2023@iitr.ac.in for more information.</p>
            </div>
            {/* <div className="abstract">
                <h2 className="compTitle">Templates</h2>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3vmax'}}>
                    <a onClick={downloadTemplate} style={{width: 'fit-content', padding: '0.5vmax 3vmax'}} className="download">Download Word Template</a>
                    <a onClick={downloadZipTemplate} style={{width: 'fit-content', padding: '0.5vmax 3vmax'}} className="download">Download LaTeX Template</a>
                </div>
            </div> */}
            <div style={{ background: '#D1D5DB', padding: '3vmax 5vmax', textAlign: 'center'}}>
                <h3 className="callforabs">Abstracts can be submitted through the <span style={{fontSize: '2.4vmax', textDecoration: 'underline'}}>Springer EquinOCS System</span></h3>
                <div style={{display: 'flex', justifyContent: 'center', gap: '3vmax'}}>
                    <a href="https://equinocs.springernature.com/service/VETOMAC2023" target="_blank" rel="noopener noreferrer" className="download" style={{textDecoration: 'none', border: 'none', padding: '0.8vmax 2.5vmax', background: '#F6F5F0'}}>Submit Abstracts</a>
                </div>
            </div>
        </div>
    )
}

export default Abstracts;